var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2803 4.21967C12.5466 4.48594 12.5708 4.9026 12.3529 5.19621L12.2803 5.28033L5.811 11.75L12.2803 18.2197C12.5466 18.4859 12.5708 18.9026 12.3529 19.1962L12.2803 19.2803C12.0141 19.5466 11.5974 19.5708 11.3038 19.3529L11.2197 19.2803L4.21967 12.2803C3.9534 12.0141 3.9292 11.5974 4.14705 11.3038L4.21967 11.2197L11.2197 4.21967C11.5126 3.92678 11.9874 3.92678 12.2803 4.21967Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2803 4.21967C19.5466 4.48594 19.5708 4.9026 19.3529 5.19621L19.2803 5.28033L12.811 11.75L19.2803 18.2197C19.5466 18.4859 19.5708 18.9026 19.3529 19.1962L19.2803 19.2803C19.0141 19.5466 18.5974 19.5708 18.3038 19.3529L18.2197 19.2803L11.2197 12.2803C10.9534 12.0141 10.9292 11.5974 11.1471 11.3038L11.2197 11.2197L18.2197 4.21967C18.5126 3.92678 18.9874 3.92678 19.2803 4.21967Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.5e3dc911f63bc86c99367fac07668db7.svg";
export { ForwardRef as ReactComponent };